import dynamic from "next/dynamic";
const DevelopersCenterHeaderComponent = dynamic(()=>import("./developers-center-header-component"));
import DevelopersCenterHeaderConfig from "./developers-center-header-config";
import DevelopersCenterHeaderAdvancedConfig from "./developers-center-header-advanced-config";
export default {
    DevelopersCenterHeaderComponent,
    DevelopersCenterHeaderConfig,
    DevelopersCenterHeaderAdvancedConfig
};
